import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getIndexMetricData, getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";

const EconomyMetrics = ({ indicators, metadata, categorizedData, geoDetails, tab, geoTag, selectionActive }: MetricPanelProps) => {  
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("economy data:", sortedMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the current tab index metric data and id
    const { indexMetricId, indexMetricData } = getIndexMetricData(tab, metadata, indicators);

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const e: DisaggregatedMetric[] = sortedMetrics[0];

    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>

            <p className="text-[10px] text-port-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-port-text mx-4 text-[10px]">Data updates published March 30, 2026.</p>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {e.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default EconomyMetrics;